type Edge<T> =
  | {
      node: T | null | undefined
    }
  | null
  | undefined

type Connection<T> = {
  edges: ReadonlyArray<Edge<T>> | null | undefined
}

export function unwrapConnection<T>(
  connection: Connection<T> | null | undefined
): T[] {
  if (!connection?.edges) return []
  return connection.edges.flatMap((edge) => (edge?.node ? [edge.node] : []))
}

/**
 * UnwrapRelayNode will peel off the edges array and return
 * the shape of the `node`.
 */
export type UnwrapRelayNode<T> = T extends {
  edges: ReadonlyArray<infer Edge> | null | undefined
}
  ? Edge extends { node: infer Node }
    ? NonNullable<Node>
    : never
  : never
